import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { BeneficiariesActions } from './beneficiaries.actions';
import { IBeneficiariesState } from './beneficiaries.state';

export const initialBeneficiariesState: IBeneficiariesState = {
  uiState: undefined,
  model: undefined,
  data: undefined,
  beneficiaryFormMode: 'none',
  addedBeneficiaries: [],
  selectedBeneficiary: undefined
};

const beneficiariesReducerFn = createReducer(
  initialBeneficiariesState,
  on(BeneficiariesActions.reset, (state: IBeneficiariesState, action) => {
    return new StateBuilder<IBeneficiariesState>(initialBeneficiariesState).build();
  }),
  on(BeneficiariesActions.addBeneficiary, (state: IBeneficiariesState, action) => {
    const { beneficiary } = action;

    const addedBeneficiaries = [...(state.addedBeneficiaries || [])];

    addedBeneficiaries.push(beneficiary);

    const mutation = { addedBeneficiaries };

    return new StateBuilder<IBeneficiariesState>(state, mutation).toLoading().build();
  }),
  on(BeneficiariesActions.removeBeneficiary, (state: IBeneficiariesState, action) => {
    const { beneficiary } = action;
    let addedBeneficiaries = [...state.addedBeneficiaries];
    if (!addedBeneficiaries?.length) {
      return { ...state };
    }
    const beneficiaryIndex = addedBeneficiaries.findIndex((b) => b.idNum == beneficiary.idNum);
    addedBeneficiaries.splice(beneficiaryIndex, 1);

    const mutation = { addedBeneficiaries };

    return new StateBuilder<IBeneficiariesState>(state, mutation).toLoading().build();
  }),
  on(BeneficiariesActions.removeAllBeneficiaries, (state: IBeneficiariesState) => {
    const mutation: Partial<IBeneficiariesState> = { addedBeneficiaries: [] };
    return new StateBuilder<IBeneficiariesState>(state, mutation).toLoading().build();
  }),
  on(BeneficiariesActions.updateBeneficiary, (state: IBeneficiariesState, action) => {
    const { beneficiary } = action;
    let addedBeneficiaries = [...(state.addedBeneficiaries ?? [])];
    if (!addedBeneficiaries?.length) {
      return { ...state };
    }
    const beneficiaryIndex = addedBeneficiaries.findIndex((b) => b.idNum == beneficiary.idNum);
    addedBeneficiaries.splice(beneficiaryIndex, 1, beneficiary);

    const mutation = { addedBeneficiaries };

    return new StateBuilder<IBeneficiariesState>(state, mutation).toLoading().build();
  }),
  on(BeneficiariesActions.selectBeneficiary, (state: IBeneficiariesState, action) => {
    const { beneficiary } = action;

    const mutation = { selectedBeneficiary: { ...beneficiary } };

    return new StateBuilder<IBeneficiariesState>(state, mutation).toLoading().build();
  }),
  on(BeneficiariesActions.updateBeneficiaryFormMode, (state: IBeneficiariesState, action) => {
    return new StateBuilder<IBeneficiariesState>(state, action).toLoading().build();
  }),
  on(BeneficiariesActions.resetBeneficiary, (state: IBeneficiariesState) => {
    state = {
      ...state,
      selectedBeneficiary: undefined
    };
    return new StateBuilder<IBeneficiariesState>(state).toLoading().build();
  }),
  on(BeneficiariesActions.load, (state: IBeneficiariesState, action) => {
    return new StateBuilder<IBeneficiariesState>(state).toLoading().build();
  }),
  on(BeneficiariesActions.loadSuccess, (state: IBeneficiariesState, action) => {
    return new StateBuilder<IBeneficiariesState>(state, action).toLoaded().build();
  }),
  on(BeneficiariesActions.submit, (state: IBeneficiariesState, action) => {
    return new StateBuilder<IBeneficiariesState>(state).toLoading().build();
  }),
  on(BeneficiariesActions.submitSuccess, (state: IBeneficiariesState, action) => {
    return new StateBuilder<IBeneficiariesState>(state, action).toLoaded().build();
  })
);
export function beneficiariesReducer(state: IBeneficiariesState | undefined, action: Action) {
  return beneficiariesReducerFn(state, action);
}
